// removed by extract-text-webpack-plugin
module.exports = {"loading":"loading-1ejEL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/home/feed/_feedStories.css
// module id = 1211
// module chunks = 1